import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import {
  DropdownDirective,
  InputDirective,
  ButtonDirective,
  SeechValidationsDirective,
  RadioDirective,
  CheckboxDirective,
} from './directives';
import {
  ValidationComponent,
  AutocompleteComponent,
  ComboSelectComponent,
  DateComponent,
  DateTimeComponent,
  TimeComponent,
  SwitchComponent,
  PhoneComponent,
  FileUploadComponent,
  SelectComponent,
  InputComponent,
  DropdownComponent,
  ComboButtonComponent,
  CheckboxComponent,
  CurrencyComponent,
  LocationComponent,
  MoneyComponent,
  TextareaComponent,
  PasswordComponent,
  MapComponent,
  StarRatingComponent,
  NestedSelectComponent,
  ExpirationDateComponent,
  ColorPickerComponent,
  // TextEditorComponent,
  FilterSortComponent,
} from './components';
import { ControlsConfig } from './injection/controls-config.model';
import { ControlsConfigService } from './injection/controls-config.service';
import { HttpClientModule } from '@angular/common/http';
import { PasscodeComponent } from './components/passcode/passcode.component';

const COMPONENTS = [
  ValidationComponent,
  AutocompleteComponent,
  ComboSelectComponent,
  FileUploadComponent,
  PhoneComponent,
  SwitchComponent,
  TimeComponent,
  DateTimeComponent,
  DateComponent,
  ButtonDirective,
  DropdownDirective,
  InputDirective,
  RadioDirective,
  SeechValidationsDirective,
  SelectComponent,
  InputComponent,
  DropdownComponent,
  ComboButtonComponent,
  CheckboxComponent,
  CurrencyComponent,
  LocationComponent,
  TextareaComponent,
  PasswordComponent,
  MoneyComponent,
  MapComponent,
  StarRatingComponent,
  NestedSelectComponent,
  ExpirationDateComponent,
  ColorPickerComponent,
  PasscodeComponent,
  // TextEditorComponent,
  FilterSortComponent,
  CheckboxDirective,
];

@NgModule({
  imports: [...COMPONENTS, HttpClientModule],
  exports: [...COMPONENTS],
  declarations: [],
})
export class ControlsNgModule {
  static forRoot(
    config: ControlsConfig
  ): ModuleWithProviders<ControlsNgModule> {
    return {
      ngModule: ControlsNgModule,
      providers: [
        ControlsConfigService,
        {
          provide: APP_INITIALIZER,
          useFactory: (controlsConfigService: ControlsConfigService) => {
            return () => {
              controlsConfigService.setConfig(config);
            };
          },
          deps: [ControlsConfigService],
          multi: true,
        },
      ],
    };
  }
}
